import { Type } from '@warp-drive/core-types/symbols';
import { collectionCommand } from 'volta/utils/api';
import Task, { TaskCommands } from './task';

import type { TForecastProjectStatus } from 'volta/models/forecast-project';
import type {
  ICreateTaskCmd,
  IDeleteTaskCmd,
  IReopenTaskCmd,
  IResolveTaskCmd,
  IUpdateTaskCmd
} from './types/tasks';

export interface ForecastProjectTaskEntityPayload {
  name: string;
  revision?: string;
  revisionNumber: number;
  description?: string;
  automlEnabled: boolean;
  status: TForecastProjectStatus;
}

export default class ForecastProjectTask extends Task<
  Record<string, any>,
  ForecastProjectTaskEntityPayload
> {
  /**
   * Commands
   */

  static createTask = collectionCommand<
    ICreateTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.CreateTask, {
    ajaxOptions: { queryParams: { include: 'createdBy,resolvedBy,assignees' } }
  });

  static updateTask = collectionCommand<
    IUpdateTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.UpdateTask);

  static deleteTask = collectionCommand<IDeleteTaskCmd, void, typeof ForecastProjectTask>(
    TaskCommands.DeleteTask
  );

  static resolveTask = collectionCommand<
    IResolveTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.ResolveTask);

  static reopenTask = collectionCommand<
    IReopenTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.ReopenTask);
  // @ts-ignore
  [Type] = 'forecast-project-task' as const;
  static modelName = 'forecast-project-task';
}
